import { Component, OnInit } from '@angular/core';
import { CmsComponentData } from '@spartacus/storefront';
import { Observable, Subscription, zip } from 'rxjs';
import { map, shareReplay, switchMap, tap } from 'rxjs/operators';
import { ProductService } from '../../../core/catalog';
import {
  Product,
  ProductReference,
  ProductReferences,
  ProductsTileComponent,
  ProductsTilesDisplayModes,
} from '../../../core/model';
import { PrincipalConfigurationService } from '../../../core/user';
import { prepareUrlForLink } from '../../../core/util';
import { hasCmsStyleClass, hasNoCmsTitleClass } from '../../../shared';
import { ProductCarouselItem } from '../../../shared/components/product-carousel';
import { CmsFeaturedProductsService } from './base/services';

@Component({
  selector: 'py-products-tiles',
  templateUrl: './products-tiles.component.html',
  styleUrls: ['./products-tiles.component.scss'],
  standalone: false,
})
export class ProductsTilesComponent implements OnInit {
  data: ProductsTileComponent;
  products$: Observable<ProductCarouselItem[]>;
  catalogProductItemSecondary$: Observable<boolean>;
  subscriptions = new Subscription();
  displayModes = ProductsTilesDisplayModes;

  constructor(
    public component: CmsComponentData<ProductsTileComponent>,
    private cmsFeaturedProductsService: CmsFeaturedProductsService,
    private productService: ProductService,
    private principalConfigurationService: PrincipalConfigurationService
  ) {}

  ngOnInit(): void {
    this.products$ = this.component.data$.pipe(
      tap((data) => {
        this.data = data;
      }),
      switchMap((data: ProductsTileComponent) =>
        data.uid ? this.cmsFeaturedProductsService.getFeaturedProductsReferences(data.uid) : []
      ),
      map((response: ProductReferences) => response?.productRefs),
      switchMap((productRef: ProductReference[]) =>
        zip(...productRef.map((productReference) => this.productService.getProduct(productReference.code)))
      ),
      map((products: Product[]) =>
        products
          .filter((product) => Boolean(product))
          .map((product) => ({ product, link: product?.url && prepareUrlForLink(product.url) }))
      ),
      shareReplay({ bufferSize: 1, refCount: true })
    );

    this.catalogProductItemSecondary$ = this.principalConfigurationService
      .isEnabled('catalogProductItemSecondary')
      .pipe(shareReplay({ bufferSize: 1, refCount: true }));
  }

  getHasClass(styleClass: string, classes: string): boolean {
    return hasCmsStyleClass(styleClass, classes);
  }

  getHasNoTitleClass(classes: string): boolean {
    return hasNoCmsTitleClass(classes);
  }
}
